import React, { useState, useEffect, useRef } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postCustomersURL } from "../utils/api";
import { useReactToPrint } from 'react-to-print';
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
    Image,
    Table,
    Thead,
    Tfoot,
    Tbody,
    Th,
    Tr,
    Td,
    VStack,
    useColorModeValue,
    Progress,
} from "@chakra-ui/react";
import EasyChekLogo from "assets/images/easychek_logo.jpg";
import OrdersTable from "views/Custom/OrdersTable";
import useGetOrdersByMechanic from "hooks/useGetOrdersByMechanic";
import Pagination from "views/Custom/Pagination";
// import Pagination from "views/Custom/Pagination";
// import useGetOrders from "hooks/useGetOrders";

function MechanicHistory({
    isOpen,
    onClose,
    userData,
}) {

    const textColor = useColorModeValue("gray.700", "white");

    const [ page, setPage ] = useState(1);
    const pageLimit = 10;
    const [ visibleColumns, setVisibleColumns ] = useState({
        "Vehicle": true,
        "Plate No.": true,
        "Odometer": true,
        "Customer": true,
        "Order Total": true,
    });

    let { 
        orders, 
        totalOrders, 
        setGettingOrders, 
        gettingOrders, 
        gettingOrdersReqSuccess 
      } = useGetOrdersByMechanic({ 
        page, 
        limit: pageLimit,
        mechanicId: userData ? userData.id : null,  
    });

    // console.log(partsTotal, laborTotal);



    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    useEffect(()=> {if(orders) console.log(orders)}, [orders]);

    useEffect(() => {
        if (userData && isOpen) {
            // console.log(userData);
            setGettingOrders(true);
        }
    }, [userData, isOpen]);


    if (userData == null) {
        return (<></>);
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{userData.firstName} {userData.lastName} Job History</ModalHeader>
                <ModalCloseButton />
                <ModalBody width={"100%"} p={"32px"}>
                    <Flex direction={"column"}>
                      
                        <Box flex="1" marginTop={2} 
                                maxHeight="74vh"
                                overflowY="auto">
                            <Table 
                                variant="simple" 
                                color={textColor} 
                            >
                            <Thead>
                                <Tr my=".8rem" p={2} color="gray.400">
                                { visibleColumns["Vehicle"] 
                                    ? <Th p={2} color="gray.400">Vehicle</Th>
                                    : null }
                                { visibleColumns["Plate No."] 
                                    ? <Th p={2} color="gray.400">Plate No.</Th>
                                    : null }
                                { visibleColumns["Odometer"] 
                                    ? <Th p={2} color="gray.400">Odometer</Th>
                                    : null }
                                { visibleColumns["Customer"] 
                                    ? <Th p={2} color="gray.400">Customer</Th>
                                    : null }
                                { visibleColumns["Order Total"] 
                                    ? <Th p={2} color="gray.400">Order Total</Th>
                                    : null }
                                </Tr>
                            </Thead>
                            <Tbody>
                                {gettingOrders ? 
                                <Tr my=".8rem" >
                                    <Td minWidth={{ sm: "250px" }} p={2} colSpan={4}>
                                    <Progress isIndeterminate />
                                    </Td>
                                </Tr>
                                : orders.map((o) => {
                                    return (
                                    <Tr my=".8rem" p={2} key={`order-row-${o.id}`}>

                                        { visibleColumns["Vehicle"] 
                                        ? <Td  p={2}>
                                            <Text>{o.carMake} {o.carType} {o.carYear}</Text>
                                            </Td>
                                        : null 
                                        } 

                                        { visibleColumns["Plate No."] 
                                        ? <Td  p={2}>
                                            <Text>{o.carPlate}</Text>
                                            </Td>
                                        : null 
                                        } 

                                        { visibleColumns["Odometer"] 
                                        ? <Td  p={2}>
                                            <Text>{o.carOdometer}</Text>
                                            </Td>
                                        : null 
                                        } 

                                        { visibleColumns["Customer"] 
                                        ? <Td p={2}>
                                            { o.customer.companyName 
                                                ? <Text>{o.customer.companyName}</Text>
                                                : <Text>{o.customer.firstName} {o.customer.lastName}</Text>
                                            }
                                            <Text>({o.customer.email})</Text>
                                            </Td>
                                        : null
                                        }
                                        { visibleColumns["Order Total"] 
                                        ? <Td  p={2}>₱{Number(o.total).toLocaleString()}</Td>
                                        : null 
                                        } 
                                    </Tr>
                                    );
                                })
                                }

                            </Tbody>
                            </Table>
                        </Box>
                        <Spacer />
                        { totalOrders != 0
                            ? <Pagination 
                            totalItems={totalOrders}
                            pageRows={pageLimit}
                            currentPage={page}
                            onPageChanged={setPage}
                            />
                            : null
                        }
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    );

}



export default MechanicHistory;
